var timezone_cookie = "ClientTimeZoneOffset";
function setCookie(key, value) {
    //Implemented after "AXPT06 – Tempo di scadenza sessione insufficiente" Axians penetration test
    let date = new Date();
    date.setTime(date.getTime() + 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toGMTString();
    samesite = "; samesite=lax";
    document.cookie = encodeURIComponent(key) + "=" + encodeURIComponent(value) + expires + samesite + "; path=/";
}

function getBaseUtcOffset() {
    // tzBaseUtcOffset: minutes from UTC (non-DST)
    // tzDstDayOffset: number of days from 1/1/2016 until first day of DST ; 0 = no DST
    var janOffset = -new Date(2016, 0, 1).getTimezoneOffset();      // Jan
    var julOffset = -new Date(2016, 6, 1).getTimezoneOffset();      // Jul
    var baseUtcOffset = Math.min(janOffset, julOffset);             // non DST offset (winter offset)

    return baseUtcOffset;
}
function getDstDayOffset() {
    // tzBaseUtcOffset: minutes from UTC (non-DST)
    // tzDstDayOffset: number of days from 1/1/2016 until first day of DST ; 0 = no DST
    var janOffset = -new Date(2016, 0, 1).getTimezoneOffset();      // Jan
    var julOffset = -new Date(2016, 6, 1).getTimezoneOffset();      // Jul
    var baseUtcOffset = getBaseUtcOffset();
    // Find first day of DST (from 1/1/2016)
    var dstDayOffset = 0;
    if (janOffset != julOffset) {
        var startDay = janOffset > baseUtcOffset ? 180 : 0; // if southern hemisphere, start 180 days into year
        for (var day = startDay; day < 365; day++) if (-new Date(2016, 0, day + 1, 12).getTimezoneOffset() > baseUtcOffset) { dstDayOffset = day; break; }    // noon
    }
    return dstDayOffset;
}

function setDaysTimeOffset() {
    // Time zone.

    var baseUtcOffset = getBaseUtcOffset();             // non DST offset (winter offset)
    setCookie("tzBaseUtcOffset", baseUtcOffset);

    var dstDayOffset = getDstDayOffset();
    setCookie("tzDstDayOffset", dstDayOffset);

    var tzIANACode = Intl.DateTimeFormat().resolvedOptions().timeZone;
    setCookie("tzIANACode", tzIANACode);
}



setDaysTimeOffset();
setCookie(timezone_cookie, new Date().getTimezoneOffset());